<template>
  <div
    class="refonte-side-menu-overlay"
    v-bind:class="{
      'side-menu-overlay--open': props.is_mobile_side_menu_open
    }"
    v-on:click="props.toggle_is_mobile_side_menu_open()" />
  <aside
    class="refonte-side-menu"
    v-bind:class="`${props.is_side_menu_reduced ? 'side-menu--reduced' : ''} ${props.is_mobile_side_menu_open ? 'side-menu-mobile--open' : ''} ${props.class}`">
    <div class="side-menu-logo">
      <img
        class="side-menu-logo-img"
        src="@/assets/img/refonte/logos/jinius.svg"
        alt="Logo Jinius" />
      <img
        class="side-menu-logo-img-reduced"
        src="@/assets/img/refonte/logos/jinius-reduced.svg"
        alt="Logo Jinius" />
      <IconClose
        class="side-menu-close"
        v-on:click="props.toggle_is_mobile_side_menu_open()" />
    </div>
    <div
      class="side-menu-espace-container"
      v-bind:class="`${espaces && espaces.length > 0 ? 'side-menu-espace-container-with-espaces' : ''} ${arborescence[selectedEspace].color ? `bg-${arborescence[selectedEspace].color}` : ''}`">
      <div class="side-menu-espace-title">
        <div class="side-menu-espace-button">
          <IconEspace />
        </div>
        <div class="side-menu-espace-title-label">Mes espaces</div>
      </div>
      <refonte-side-menu-collapse
        v-bind:show_dropdown="showDropdown"
        class="self-stretch"
        v-bind:is_reduced="isReducedDesktop"
        v-bind:title="arborescence[selectedEspace].label"
        v-bind:title_pastille="
          arborescence[selectedEspace].color
            ? arborescence[selectedEspace].color
            : 'jinius-green'
        ">
        <template
          v-if="showDropdown"
          v-for="(espace, index) in espaces.filter((e) => e !== selectedEspace)"
          v-bind:key="index">
          <refonte-side-menu-espace-item
            v-if="
              arborescence[espace] &&
              !arborescence[espace].restricted &&
              arborescence[espace].id != 'account'
            "
            v-bind:pastille="
              arborescence[espace].color
                ? arborescence[espace].color
                : 'jinius-green'
            "
            v-bind:is_reduced="isReducedDesktop"
            v-bind:on_click="() => navigateToSpace(espace)"
            v-bind:label="arborescence[espace].label" />
          <div v-else />
        </template>
      </refonte-side-menu-collapse>
    </div>
    <div class="side-menu-links">
      <div class="side-menu-links-top">
        <div class="side-menu-links-categories">
          <template
            v-bind:key="rubrique"
            v-for="rubrique in Object.keys(
              arborescence[selectedEspace].rubriques
            )">
            <side-menu-category
              v-if="
                !arborescence[selectedEspace].rubriques[rubrique]
                  .need_admin_rights ||
                (arborescence[selectedEspace].rubriques[rubrique]
                  .need_admin_rights &&
                  hasAdminRights)
              "
              v-bind:title="
                arborescence[selectedEspace].rubriques[rubrique].label
              "
              v-bind:reduced_title="
                arborescence[selectedEspace].rubriques[rubrique].reduced_label
              ">
              <template
                v-bind:key="sousRubrique"
                v-for="sousRubrique in Object.keys(
                  arborescence[selectedEspace].rubriques[rubrique]
                    .sous_rubriques
                )">
                <side-menu-link
                  v-if="
                    !arborescence[selectedEspace].rubriques[rubrique]
                      .sous_rubriques[sousRubrique].menuHidden
                  "
                  v-bind:url="`/${selectedEspace}/${sousRubrique}`"
                  v-bind:label="
                    arborescence[selectedEspace].rubriques[rubrique]
                      .sous_rubriques[sousRubrique].label
                  "
                  v-bind:compteur="
                    arborescence[selectedEspace].id === 'formateur' &&
                    arborescence[selectedEspace].rubriques[rubrique]
                      .sous_rubriques[sousRubrique].id === 'contrats'
                      ? contratsASignerCount
                      : undefined
                  "
                  v-bind:active="
                    route.path == `/${selectedEspace}/${sousRubrique}`
                  ">
                  <component
                    v-bind:is="
                      ICONS[
                        arborescence[selectedEspace].rubriques[rubrique]
                          .sous_rubriques[sousRubrique].icon
                      ]
                    " />
                </side-menu-link>
              </template>
            </side-menu-category>
          </template>
        </div>
      </div>
      <div class="side-menu-links-bottom">
        <div class="side-menu-version">{{ version }}</div>
      </div>
    </div>
    <div
      class="side-menu-reduce"
      v-on:click="props.toggle_is_side_menu_reduced">
      <div class="side-menu-reduce-icon">
        <IconExpand v-if="props.is_side_menu_reduced" />
        <IconReduce v-else />
      </div>
    </div>
  </aside>
</template>

<script setup lang="ts">
  import IconClose from '@/assets/img/refonte/icons/display/icon-close.svg?component';
  import IconEspace from '@/assets/img/refonte/icons/profil/icon-espace.svg?component';
  import IconExpand from '@/assets/img/refonte/icons/display/icon-expand.svg?component';
  import IconReduce from '@/assets/img/refonte/icons/display/icon-reduce.svg?component';
  import sideMenuCategory from '@/components/refonte/side-menu/refonte-side-menu-category.vue';
  import sideMenuLink from '@/components/refonte/side-menu/refonte-side-menu-link.vue';
  import RefonteSideMenuCollapse from '@/components/refonte/side-menu/refonte-side-menu-collapse.vue';
  import RefonteSideMenuEspaceItem from '@/components/refonte/side-menu/refonte-side-menu-espace-item.vue';
  import { computed, ComputedRef, ref } from 'vue';
  import { useRoute, useRouter } from 'vue-router';
  import { ICONS } from '@/store/constants/Icons';
  import { useArborescenceStore } from '@/stores/arborescence';
  import { storeToRefs } from 'pinia';
  import { useEntrepriseStore } from '@/stores/entreprise';
  import { Entreprise } from '@/types/gestion/entreprise';
  import { useAccountStore } from '@/stores/account';
  import { useFormateurStore } from '@/stores/formateur';

  const props = withDefaults(
    defineProps<{
      is_mobile_side_menu_open: boolean;
      is_side_menu_reduced: boolean;
      toggle_is_mobile_side_menu_open: Function;
      toggle_is_side_menu_reduced: Function;
      class?: string;
    }>(),
    {
      class: ''
    }
  );

  const arborescenceStore = useArborescenceStore();
  const { arborescence } = storeToRefs(arborescenceStore);

  const formateurStore = useFormateurStore();
  const { contratsASignerCount } = storeToRefs(formateurStore);

  const espaces = Object.keys(arborescence.value);
  const route = useRoute();
  const router = useRouter();
  const selectedEspace = computed(() => route.params.space_id);
  const isReducedDesktop = computed(() => {
    return props.is_side_menu_reduced && !props.is_mobile_side_menu_open;
  });
  const version = computed(() => `Version ${import.meta.env.VITE_VERSION}`);
  function navigateToSpace(espace: string) {
    router.push(`/${espace}`);
  }
  const entrepriseStore = useEntrepriseStore();

  const { entreprises, activeEntrepriseIds } = storeToRefs(entrepriseStore);

  const selectedEntities: ComputedRef<Entreprise[]> = computed(() => {
    const activeEntities = entreprises.value.filter((e: Entreprise) =>
      activeEntrepriseIds.value.includes(e.entrepriseId)
    );
    return activeEntities.length > 0 ? activeEntities : [];
  });

  const hasAdminRights: ComputedRef<boolean> = computed(() => {
    if (activeEntrepriseIds.value.length > 0) {
      return selectedEntities.value.some(
        (e: Entreprise) => e.droitAdministrateur
      );
    } else {
      return (
        entreprises.value.filter((e: Entreprise) => e.droitAdministrateur)
          .length > 0
      );
    }
  });
  const accountStore = useAccountStore();
  const { profile } = storeToRefs(accountStore);
  const isAccountPage = computed(() => selectedEspace.value == 'account');

  const computeNumberOfActivePage = () =>
    espaces.filter(
      (espace) =>
        arborescence.value[espace] &&
        !arborescence.value[espace].restricted &&
        arborescence.value[espace].id != 'account'
    ).length;

  const computeShowDropdown = () =>
    profile?.value?.hasValidateContactInfo &&
    (numberOfActivePage.value > 1 ||
      (isAccountPage.value && numberOfActivePage.value > 0));

  const numberOfActivePage = ref(computeNumberOfActivePage());
  accountStore.$subscribe((mutation, state) => {
    if (
      mutation.events?.newValue?.hasValidateContactInfo !=
      mutation?.events?.oldValue?.hasValidateContactInfo
    ) {
      refreshValues();
    }
  });
  const showDropdown = ref(computeShowDropdown());
  arborescenceStore.$subscribe((mutation, state) => {
    refreshValues();
  });
  const refreshValues = () => {
    numberOfActivePage.value = computeNumberOfActivePage();
    showDropdown.value = computeShowDropdown();
  };
</script>

<style lang="scss" scoped>
  .refonte-side-menu-overlay {
    @apply hidden;

    @media (max-width: 767.98px) {
      &.side-menu-overlay--open {
        @apply absolute bottom-0 left-0 right-0 top-0 block bg-black/50;
        z-index: 40;
      }
    }
  }
  .refonte-side-menu {
    @apply relative flex shrink-0 flex-col items-start self-stretch bg-refonte-menu text-refonte-white;
    width: 208px;
    transition:
      width 0.2s,
      left 0.2s;
    z-index: 50;

    .side-menu-logo {
      @apply flex items-center self-stretch;
      height: 80px;
      padding: 16px 24px;
      transition: padding 0.2s;

      .side-menu-logo-img {
        width: 85px;
        height: 34px;
      }
      .side-menu-logo-img-reduced {
        @apply hidden;
      }
      .side-menu-close {
        @apply hidden;
      }
    }
    .side-menu-espace-container {
      @apply flex flex-col items-start self-stretch;
      padding: 12px;
      transition: padding 0.2s;
      gap: 10px;

      .side-menu-espace-title {
        @apply flex items-center self-stretch whitespace-nowrap text-refonte-white;
        height: 20px;
        gap: 10px;
        padding: 0 11px 4px;
        font-size: 14px;
        line-height: 120%;
        font-weight: 500;
        text-transform: uppercase;
      }
      .side-menu-espace {
        @apply flex items-center self-stretch;
        height: 44px;
        border-radius: 4px;

        .side-menu-espace-button {
          @apply flex shrink-0 items-center justify-center self-stretch;
          width: 44px;
          height: 44px;
          padding: 10px;
          border-radius: 4px 0 0 4px;
        }
        .side-menu-espace-dropdown {
          @apply flex flex-grow items-center justify-between self-stretch bg-refonte-white;
          border-radius: 4px;
          height: 44px;
          padding: 0 10px;

          span {
            @apply text-refonte-black;
            font-size: 14px;
            font-weight: 500;
            line-height: 14px;
          }

          :deep(svg) {
            width: 16px;
          }
        }
      }
      &.side-menu-espace-container-with-espaces {
        .side-menu-espace {
          @apply cursor-pointer;

          &:hover {
            @apply bg-refonte-menu-40;
          }

          .side-menu-espace-dropdown {
            :deep(svg) {
              @apply inline-block;
              width: 16px;
            }
          }
        }
      }
    }
    .side-menu-catalogue {
      @apply self-stretch;
      padding: 24px 16px 8px;
    }
    .side-menu-links {
      @apply flex flex-grow flex-col items-start justify-between self-stretch overflow-y-auto overflow-x-hidden;
      gap: 16px;
      padding: 8px 16px 24px;
      max-height: calc(100vh - 72px - 76px - 72px);
      transition: padding 0.2s;

      &::-webkit-scrollbar {
        display: none !important;
      }

      .side-menu-links-top {
        @apply flex flex-col items-start self-stretch;
        gap: 16px;

        .side-menu-links-categories {
          @apply flex flex-col items-start self-stretch;
          gap: 24px;
        }
      }
      .side-menu-links-bottom {
        @apply flex flex-col items-start self-stretch;

        .side-menu-version {
          @apply flex items-center justify-center self-stretch text-center text-refonte-white-30;
          height: 20px;
          gap: 10px;
          padding: 0 11px;
          font-size: 12px;
          line-height: 120%;
          font-weight: 500;
        }
      }
    }
    .side-menu-reduce {
      @apply hidden;
    }

    @media (min-width: 768px) {
      &.side-menu--reduced {
        width: 64px;
        overflow: hidden;

        .side-menu-logo {
          padding: 16px 12px;

          .side-menu-logo-img {
            @apply hidden;
          }
          .side-menu-logo-img-reduced {
            @apply block;
            width: 40px;
            height: 40px;
          }
        }
        .side-menu-espace-container {
          padding: 16px 10px;

          .side-menu-espace-title {
            @apply justify-center;
            padding: 0 0 4px;
            .side-menu-espace-title-label {
              @apply hidden;
            }
          }
          .side-menu-espace {
            .side-menu-espace-button {
              @apply bg-refonte-white;
              border-radius: 4px;

              :deep(svg) {
                @apply text-refonte-black;
                width: 20px;
                height: 20px;
              }
            }
            .side-menu-espace-dropdown {
              @apply hidden;
            }
          }
        }
        .side-menu-catalogue {
          padding: 24px 8px 8px;
        }
        .side-menu-links {
          padding: 8px 8px 24px;

          .side-menu-links-bottom {
            .side-menu-version {
              @apply hidden;
            }
          }
        }
      }
      .side-menu-reduce {
        @apply absolute flex cursor-pointer items-center justify-center bg-refonte-menu;
        width: 24px;
        height: 32px;
        right: -12px;
        top: 20px;
        border-radius: 4px;
        box-shadow: 4px 4px 12px 0 rgba(0, 0, 0, 0.25);

        .side-menu-reduce-icon {
          @apply flex shrink-0 items-center justify-center;
          width: 20px;
          height: 20px;

          :deep(svg) {
            @apply text-refonte-white-30;
            width: 20px;
            height: 20px;
          }
        }
      }
    }
    @media (max-width: 767.98px) {
      @apply absolute bottom-0 top-0;
      width: 272px;
      left: -272px;

      &.side-menu-mobile--open {
        @apply left-0;
      }

      .side-menu-logo {
        @apply justify-between;
        height: 56px;
        padding: 0 16px 0 32px;

        .side-menu-close {
          @apply block cursor-pointer text-refonte-white;
          height: 12px;
          width: 12px;
        }
      }
      .side-menu-espace-container {
        padding: 6px 8px;

        .side-menu-espace {
          @apply flex items-center self-stretch bg-refonte-menu-30;
          height: 44px;
          border-radius: 4px;
        }
      }
      .side-menu-catalogue {
        padding: 8px 16px 4px;
      }
      .side-menu-links {
        padding: 4px 16px 8px;
        max-height: calc(100vh - 56px - 56px - 48px);

        .side-menu-links-top {
          gap: 8px;

          .side-menu-links-categories {
            gap: 12px;
          }
        }
      }
    }
    :deep(.refonte-dropdown) {
      .dropdown-container {
        top: calc(100% + 2px);
        box-shadow: 0 3px 9px 0 rgba(45, 50, 65, 0.2);
        min-width: auto;
      }
    }
  }
  .collapse-header {
    @apply flex cursor-pointer items-center justify-between bg-refonte-white;
    padding: 8px;
    border-radius: 4px;
    width: 100%;
    .collapse-header-content {
      @apply flex flex-wrap items-center;

      .collapse-header-title {
        @apply flex items-center;
        padding: 6px 10px;
        gap: 8px;
        span {
          @apply text-refonte-black;
          font-size: 14px;
          font-weight: 500;
          line-height: 14px;

          &.collapse-header-title-text {
            font-size: 14px;
            line-height: 18px;
          }
        }
      }
    }
    .collapse-header-chevron {
      @apply flex shrink-0 items-center justify-center;
      width: 32px;

      :deep(svg) {
        @apply text-refonte-black;
        width: 20px;
        height: 20px;
      }
    }
  }
</style>
